(async () => {
    if (document.querySelector('[data-project-header-image-carousel-trigger]')) {
        await import('~/components/project-header/project-header-lazy');
    }
})();
